/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_9_AInputs */

const en_vc_faq_9_a = /** @type {(inputs: Vc_Faq_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. This is an independent guide. The official page is getartcraft.com/apps/vectorcraft, and every download here links to the official GitHub releases.`)
};

const zh_vc_faq_9_a = /** @type {(inputs: Vc_Faq_9_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是，这是一个独立的介绍站。官方页面是 getartcraft.com/apps/vectorcraft，本站所有下载链接都指向 GitHub 官方发布页。`)
};

/**
* | output |
* | --- |
* | "No. This is an independent guide. The official page is getartcraft.com/apps/vectorcraft, and every download here links to the official GitHub releases." |
*
* @param {Vc_Faq_9_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_9_a = /** @type {((inputs?: Vc_Faq_9_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_9_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_9_a(inputs)
	return zh_vc_faq_9_a(inputs)
});
export { vc_faq_9_a as "vc.faq.9.a" }